module.exports = __webpack_public_path__ + "img/zhili.29de4f58.jpg";